class Drawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );

    this.overlay = this.querySelector(".drawer__overlay");
    if (this.overlay) {
      this.overlay.addEventListener("click", this.close.bind(this));
    }
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);

    setTimeout(() => {
      this.classList.add("animate", "active");
    });

    this.addEventListener(
      "transitionend",
      () => {
        const focusTarget = this.getFocusTarget();
        const focusElement =
          this.querySelector(".drawer__inner") ||
          this.querySelector(".drawer__close");
        trapFocus(focusTarget, focusElement);
      },
      { once: true }
    );

    document.body.classList.add("overflow-hidden");
  }

  close() {
    document.body.classList.remove("overflow-hidden");
    this.classList.remove("active");
    removeTrapFocus(this.activeElement);
  }

  getFocusTarget() {
    return this.querySelector(".drawer__inner");
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}
